import React, { useEffect, useState } from 'react';
import { listCampaigns, listCompanies } from '../../api/catalogImportApi';
import { input, label } from './styles';

/**
 * Optional Brandstore target for an import: company, then one of its campaigns. Empty = plain
 * catalogue import. {@code value} is { companyId, campaignId } as strings ('' = none).
 */
export default function CampaignPicker({ value, onChange, disabled }) {
  const [companies, setCompanies] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    listCompanies()
      .then((r) => setCompanies((r.data || []).slice().sort((a, b) => a.displayName.localeCompare(b.displayName))))
      .catch(() => setLoadError('Could not load Brandstore companies.'));
  }, []);

  useEffect(() => {
    if (!value.companyId) { setCampaigns([]); return; }
    listCampaigns(value.companyId)
      .then((r) => setCampaigns((r.data || []).filter((c) => c.status !== 'ENDED')))
      .catch(() => setLoadError('Could not load that company’s campaigns.'));
  }, [value.companyId]);

  return (
    <>
      <div>
        <label style={label} htmlFor="catalog-company">Brandstore company (optional)</label>
        <select id="catalog-company" style={input} value={value.companyId} disabled={disabled}
                onChange={(e) => onChange({ companyId: e.target.value, campaignId: '' })}>
          <option value="">— Main catalogue only —</option>
          {companies.map((c) => <option key={c.id} value={String(c.id)}>{c.displayName}</option>)}
        </select>
      </div>
      <div>
        <label style={label} htmlFor="catalog-campaign">Add to campaign</label>
        <select id="catalog-campaign" style={input} value={value.campaignId} disabled={disabled || !value.companyId}
                onChange={(e) => onChange({ ...value, campaignId: e.target.value })}>
          <option value="">{value.companyId ? 'Choose a campaign…' : '—'}</option>
          {campaigns.map((c) => (
            <option key={c.id} value={String(c.id)}>{c.name}{c.status === 'PAUSED' ? ' (paused)' : ''}</option>
          ))}
        </select>
        {value.companyId && campaigns.length === 0 && !loadError && (
          <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 4 }}>No active campaigns for this company.</div>
        )}
        {loadError && <div role="alert" style={{ fontSize: 11, color: '#B91C1C', marginTop: 4 }}>{loadError}</div>}
      </div>
    </>
  );
}
